/* eslint-disable @next/next/no-html-link-for-pages */
'use client';
import { useRouter } from 'next/navigation';
import { useTranslation } from 'next-i18next';

import { Button, Flex } from '@chakra-ui/react';

import { Error } from '@app/components/organisms/error';
import { environment } from '@app/environments/environment';

export const InternalError = () => {
    const imgSrc = `${
        environment.NOCIMG_URL || 'https://d.nocimg.pl'
    }/gfx/nocowanie_pl/mf/common/error/error.svg`;

    const { t } = useTranslation('common');
    const { refresh } = useRouter();

    return (
        <Error
            code={500}
            imgSrc={imgSrc}
            translationData={{
                reason: t('errorPage.internalErrorReason'),
            }}
        >
            <Flex flexDirection={{ base: 'column', md: 'row' }} gap="gutterWidth">
                <Button
                    colorPalette="secondary"
                    variant="solid"
                    fontSize="md"
                    onClick={() => refresh()}
                >
                    {t('errorPage.refresh')}
                </Button>
                <Button asChild colorPalette="secondary">
                    <a href="/">{t('errorPage.goBack')}</a>
                </Button>
            </Flex>
        </Error>
    );
};
